import * as React from 'react';

import { IPage } from '../../../../../../infrastructure/interfaces';
import { placeholderTypes } from '../../../../../../infrastructure/placeholderTypes';
import MarkdownRenderer from '../MarkdownRenderer';
import {LayoutType} from "../../../../../../infrastructure/LayoutTypes";

export interface ITableOfContent {
  data: {
    pages: IPage[];
  };
}

export default class TableOfContent extends React.Component<ITableOfContent> {
  constructor(props: ITableOfContent) {
    super(props);
  }

  renderSvg() {
    return (
      <svg version="1.1" id="Layer_1" x="0px" y="0px"
        viewBox="0 0 267.8 22.9" preserveAspectRatio="none">
        <rect width="267.8" height="22.9" />
      </svg>
    );
  }

  buildTableOfContentItem = (pages: any) => {
    const tableContent = [];
    for (let i = 0; i < pages.length; i += 1) {
      if (pages[i].placeholders[0].type === placeholderTypes.Divider
          || pages[i].placeholders[0].type === placeholderTypes.SeedDivider
          || pages[i].placeholders[0].type === placeholderTypes.Product) {
        tableContent.push(pages[i]);
      }
    }
    const columnHeight = 50;
    const maxColumnCount = 2;
    const rows = new Array(columnHeight);
    for (let i = 0; i < columnHeight; i += 1) {
      rows[i] = new Array(maxColumnCount);
    }

    let currentRow = 0;
    let currentColumn = 0;

    for (let i = 0; i < columnHeight * maxColumnCount; i += 1) {
      if ((currentColumn >= maxColumnCount) || (currentRow >= columnHeight)) {
        break;
      }

      if (tableContent[i] && tableContent[i].placeholders.length) {
        // Shelf Divider
        if (tableContent[i].placeholders[0].type === placeholderTypes.Divider) {
          const category = ((tableContent[i].placeholders.length > 0) && (tableContent[i].placeholders[0].data != null)) ? tableContent[i].placeholders[0].data.category : null;
          const notFirst = currentRow !== 0 ? 'group-not-first' : '';
          const categoryName = (category != null) ? category.name : "";
          rows[currentRow][currentColumn] = (
            <td
              key={categoryName}
              className={`TOC-group TOC-group-${categoryName.replace(/\s/g, '-')} colm-${currentColumn} ${notFirst}`}
              rowSpan={2}
            ><div>
                {this.renderSvg()}
                {categoryName}
              </div>
            </td>);
          currentRow += 2;
        }
        // Seed Divider
        else if (tableContent[i].placeholders[0].type === placeholderTypes.SeedDivider) {
          const category = tableContent[i].placeholders[0].data.category;
          const notFirst = currentRow !== 0 ? 'group-not-first' : '';
          const categoryName = (category != null) ? category.name : "";
          rows[currentRow][currentColumn] = (
              <td
                  key={categoryName}
                  className={`TOC-group TOC-group-Seed colm-${currentColumn} ${notFirst}`}
                  rowSpan={2}
              ><div>
                {this.renderSvg()}
                {categoryName}
              </div>
              </td>);
          currentRow += 2;
        }
        // Agronomy Chart
        else if ((tableContent[i].layout == LayoutType.Agronomy) && (tableContent[i].position == "left")) {
          const productName = tableContent[i].placeholders[0].data.category.name;
          const productNumber = tableContent[i].number;
          const key = productName + productNumber;
          rows[currentRow][currentColumn] = (
              <td className={`colm-${currentColumn} TOC-product`} key={key} >
                <div>
                  <MarkdownRenderer
                      markdown={"Agronomy Chart - " + productName}
                      key={key}
                      Element="span" />
                  <span key="page-number">{productNumber}</span>
                </div>
              </ td>);
          currentRow += 1;
        }
        // Multiple products
        else if ((tableContent[i].layout == LayoutType.MultiLayout)  && (tableContent[i].position == "left")) {
          // Product owner decided to leave this out for now
          // const productNumber = tableContent[i].number;
          // const key = "mutli-layout" + productNumber;
          // rows[currentRow][currentColumn] = (
          //     <td className={`colm-${currentColumn} TOC-product`} key={key} >
          //       <div>
          //         <MarkdownRenderer
          //             markdown={"Multiple Products"}
          //             key={key}
          //             Element="span" />
          //         <span key="page-number">{productNumber}</span>
          //       </div>
          //     </ td>);
          currentRow += 1;
        }
        // Full page product
        else if (tableContent[i].placeholders[0].type === placeholderTypes.Product) {

          const product = tableContent[i].placeholders[0].data;
          const productName = product.name;
          const productNumber = tableContent[i].number;
          const key = productName + productNumber;
          rows[currentRow][currentColumn] = (
            <td className={`colm-${currentColumn} TOC-product`} key={key} >
              <div>
                <MarkdownRenderer
                  markdown={productName}
                  key={key}
                  Element="span" />
                <span key="page-number">{productNumber}</span>
              </div>
            </ td>);
          currentRow += 1;
        }
      }

      // Increment the row
      if (currentRow >= (columnHeight - 1)) {
        currentRow = 0;
        currentColumn += 1;
      }
    }
    return (<tbody>
      {rows.map((r, index) => <tr key={index}>{...r}</tr>)}
    </tbody>);
  }
  render() {
    return (
      <div className="table-of-content-container">
        <div className={`table-of-content-header`}>
          <div className="TOC-header-title">Table of Contents</div>
        </div>
        <table className={`table-of-content-body`}>
          {this.buildTableOfContentItem(this.props.data.pages)}
        </table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Editor/components/CropPageView/common/PageTypes/TableOfContents.tsx